<div class="wrapper">
  <div class="container px-0">
    <!--<h5 class="main-title fw-bold mb-4">{{patientpersonalinfo?.PracticeName}}</h5>-->
    <div class="px-2">
      <div class="row justify-content-center">
        <div class="col-md-6">

          <div class="card border">

            <div class="card-body p-0 text-center">
              <h5 class="bg-info font-weight-bold mb-0 p-3 text-white">
                {{'RegistrationThankYou.RegistrationCompleted' | translate}}
              </h5>
              <p class="mb-0 p-3" style="font-size:20px !important;">{{appointmentMessage}}</p>
              <h5 class="bg-light font-weight-bold mb-0 p-3 text-info text-success">
                {{'RegistrationThankYou.RegistrationThankYou_thankYou' | translate}}
              </h5>
            </div>

          </div>

        </div>
      </div>
    </div>



  </div>
</div>



<footer class="p-3">
  <div class="container p-0">
    <div class="row justify-content-center">
      <div class="col-auto text-center">
        <a *ngIf="allowPaymentBeforeCheckin && !isNewPatient" class="btn btn-primary btn-sm p-2" type="button"
          (click)="paynow()">{{'button.payForYouAppointment' | translate}}</a>
      </div>
    </div>
  </div>
</footer>